<svelte:options runes={false} />

<script lang="ts">
	import { onDestroy } from 'svelte';
	import type { ComponentType } from 'svelte';

	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	import RouteLoading from './RouteLoading.svelte';

	import {
		bindMainLayoutSelection,
		createLatestLayoutSelection,
		mainLayoutLoader,
		type MainLayoutLoadState,
	} from './main-layout-loader';

	let component: ComponentType;
	let error: unknown;
	let loading = true;

	const updateLoadState = (state: MainLayoutLoadState) => {
		component = state.component;
		error = state.error;
		loading = state.loading;
	};

	const layoutSelection = createLatestLayoutSelection(mainLayoutLoader.load, updateLoadState);
	const unsubscribeLayoutSelection = bindMainLayoutSelection(showNewLayout, layoutSelection);

	onDestroy(unsubscribeLayoutSelection);
</script>

{#if loading}
	<RouteLoading />
{:else if error}
	<RouteLoading {error} onRetry={layoutSelection.retry} />
{:else if component}
	<svelte:component this={component} />
{/if}
